import {KEY_CODES} from "./keyCodes";

export enum KEYBOARD_ACTIONS {
  PREVIOUS = KEY_CODES.UP,
  NEXT     = KEY_CODES.DOWN,
  ENTER    = KEY_CODES.SPACE
}
